import type { SSEEvent } from 'Types/aemui/laic-chat/sse';

// The gateway sends more than these; dropping the rest keeps `SSEEvent` honest.
const HANDLED_EVENTS = new Set(['delta', 'terminal']);

export async function* parseSSEStream(response: Response): AsyncGenerator<SSEEvent> {
	const reader = response.body?.getReader();
	if (!reader) {
		return;
	}

	const decoder = new TextDecoder();
	let buffer = '';
	try {
		let streamData = await reader.read();
		buffer += decoder.decode(streamData.value, { stream: true });
		while (!streamData.done) {
			const parts = buffer.split('\n\n');
			buffer = parts.pop() ?? '';

			for (const part of parts) {
				const event = parseSSEBlock(part);
				if (event) {
					yield event;
				}
			}
			streamData = await reader.read();
			buffer += decoder.decode(streamData.value, { stream: true });
		}
		if (buffer.trim()) {
			const event = parseSSEBlock(buffer);
			if (event) {
				yield event;
			}
		}
	} finally {
		reader.releaseLock();
	}
}

function parseSSEBlock(block: string): SSEEvent | null {
	let eventType = '';
	let data = '';

	for (const line of block.split('\n')) {
		if (line.startsWith('event:')) {
			eventType = line.slice(6).trim();
		} else if (line.startsWith('data:')) {
			data = line.slice(5).trim();
		}
	}

	if (!HANDLED_EVENTS.has(eventType) || !data) {
		return null;
	}

	try {
		const parsed = JSON.parse(data);
		return { event: eventType, ...parsed } as SSEEvent;
	} catch {
		return null;
	}
}
